import { render, staticRenderFns } from "./discussion-share.vue?vue&type=template&id=6cee96e0&scoped=true&"
import script from "./discussion-share.vue?vue&type=script&lang=js&"
export * from "./discussion-share.vue?vue&type=script&lang=js&"
import style0 from "./discussion-share.vue?vue&type=style&index=0&id=6cee96e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cee96e0",
  null
  
)

export default component.exports